import api from './index'

export default {

    /**
     * Get results
     * @param id
     * @param params
     */
    getResults(id, params) {
        return api
            .get(`/imports/${id}/results`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show
     * @param id
     * @param params
     */
    show(id, params) {
        return api
            .get(`/imports/${id}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Cancel
     * @param id
     * @param data
     */
    cancel(id, data) {
        return api
            .post(`/imports/${id}/cancel`, data)
            .then(response => {
                return response.data
            })
    },

}
